import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText, Spinner } from 'reactstrap';
import { ref, get } from 'firebase/database';
import { db } from '../../../../firebase';
import { errorToast } from '../../../common/toast';

const SubmitForms = () => {
    const [submittedForms, setSubmittedForms] = useState([]);
    const [loading, setLoading] = useState(true);
    const userData = JSON.parse(localStorage.getItem('user') || '{}');

    const fetchSubmittedForms = useCallback(async () => {
        setLoading(true); // Start loading
        try {
            const formsRef = ref(db, `userForms`);
            const formsSnapshot = await get(formsRef);

            if (formsSnapshot.exists()) {
                const allFormsData = formsSnapshot.val();
                let userForms = null;

                Object.entries(allFormsData).forEach(([key, value]) => {
                    if (value.userId === userData?.uid) {
                        userForms = value; // Match found
                    }
                });

                if (userForms) {
                    const array = Object.entries(userForms).reduce((acc, [key, value]) => {
                        if (key.startsWith('para')) {
                            acc.push({ ...value, name: key, id: parseInt(key.slice(4), 10) });
                        }
                        return acc;
                    }, []);

                    array.sort((a, b) => a.id - b.id);
                    setSubmittedForms(array);
                } else {
                    setSubmittedForms([]);
                }
            } else {
                setSubmittedForms([]);
            }
        } catch (error) {
            errorToast("Error fetching submitted forms: ", error);
        } finally {
            setLoading(false); // End loading
        }
    }, [userData]);

    useEffect(() => {
        fetchSubmittedForms();
    }, []);

    return (
        <Container className="mt-4">
            <h4>Your Submitted Forms</h4>
            {loading ? (
                <div className="text-center">
                    <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                    <p>Loading your submitted forms...</p>
                </div>
            ) : (
                <Row>
                    {submittedForms.map((form) => (
                        <Col md="12" key={form.id} className="mb-4">
                            <Card>
                                <CardBody>
                                    <CardTitle tag="h5">Form {form.id}</CardTitle>
                                    <Row>
                                        {/* Original Paragraph */}
                                        <Col xs="6">
                                            <CardText>
                                                <strong>Original Paragraph:</strong>
                                                <div className="no-copy-card">
                                                    <p>{form.original || "No data available"}</p>
                                                </div>
                                            </CardText>
                                        </Col>

                                        {/* User Input */}
                                        <Col xs="6">
                                            <CardText>
                                                <strong>Your Response:</strong>
                                                <p>{form.userInput || "No response submitted"}</p>
                                            </CardText>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </Container>
    );
};

export default SubmitForms;
